"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const preact_1 = require("preact");
const formik_1 = require("formik");
const validation_1 = require("../lib/validation");
const field_group_1 = __importDefault(require("./form/field-group"));
const fields_1 = require("./form/fields");
const layout_1 = __importDefault(require("./form/layout"));
const icons_1 = require("./form/icons");
const initialValues = {
    email: '',
};
function NewsletterForm({ list }) {
    function handleSubmit(values, { setStatus, setValues, setTouched }) {
        return __awaiter(this, void 0, void 0, function* () {
            if (process.env.NODE_ENV !== 'production') {
                yield new Promise(resolve => {
                    setTimeout(resolve, 2000);
                });
                setValues(initialValues);
                setTouched({});
                setStatus(true);
                return;
            }
            try {
                const response = yield fetch(`/wp-json/compleat/v1/subscribe/${list}`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(values),
                });
                if (!response.ok) {
                    throw response;
                }
                setValues(initialValues);
                setTouched({});
                setStatus(true);
                return response;
            }
            catch (error) {
                console.error(error);
            }
        });
    }
    function validate(values) {
        const errors = {};
        if (values.email === '') {
            errors.email = 'Please enter your email address';
        }
        else if (!(0, validation_1.isValidEmail)(values.email)) {
            errors.email = 'Please enter a valid email address';
        }
        return errors;
    }
    return ((0, preact_1.h)(formik_1.Formik, { initialValues: initialValues, initialStatus: false, validate: validate, onSubmit: handleSubmit },
        (0, preact_1.h)(formik_1.Form, { noValidate: true },
            (0, preact_1.h)(NewsletterFormFields, null))));
}
exports.default = NewsletterForm;
function NewsletterFormFields() {
    const { isSubmitting, status: isSubmitted } = (0, formik_1.useFormikContext)();
    const hideForm = isSubmitting || isSubmitted;
    return ((0, preact_1.h)(layout_1.default, null,
        (0, preact_1.h)(layout_1.default.Fields, null,
            (0, preact_1.h)("div", { className: `sm:flex transition-opacity ${isSubmitting && 'opacity-30'}` },
                (0, preact_1.h)("div", { className: 'sm:flex-1 sm:pr-2' },
                    (0, preact_1.h)(field_group_1.default, null,
                        (0, preact_1.h)(fields_1.TextField, { type: 'email', name: 'email', placeholder: 'Email address', size: 1, disabled: hideForm }),
                        (0, preact_1.h)(field_group_1.default.Status, { name: 'email' }))),
                (0, preact_1.h)("div", { className: 'sm:flex-shrink-0 mt-2 sm:mt-0' },
                    (0, preact_1.h)("button", { type: 'submit', disabled: hideForm, className: 'block w-full border-2 border-teal px-5 md:px-8 py-3 font-heading text-lg text-turquoise-dark leading-5 xs:leading-5 uppercase transition-colors hover:bg-teal hover:text-white' }, "Register")))),
        (0, preact_1.h)("div", { "aria-live": 'polite' },
            (0, preact_1.h)(SuccessOverlay, null))));
}
function SuccessOverlay() {
    const { status } = (0, formik_1.useFormikContext)();
    if (!status) {
        return null;
    }
    return ((0, preact_1.h)("div", { className: 'absolute inset-0 z-10 flex items-center justify-center rounded bg-turquoise-dark font-bold text-white' },
        (0, preact_1.h)(icons_1.TickIcon, { className: 'h-4 w-4 fill-current' }),
        (0, preact_1.h)("span", { className: 'ml-1' }, "Thanks for registering")));
}
